var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"save-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fat', 'vial']}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }